{
    "CrmLicenceType_SOLO": "Solo",
    "CrmLicenceType_TEAMS": "Teams",
    "CrmLicenceType_UNITE": "Unite",
    "CrmLicenceType_NONE": "None",
    "NAME": "CrmLicenceTypes"
}
